<div class="user-service-surface-block"
     [class.mobile]="deviceService.isMobile()"
     [class.tablet]="deviceService.isTablet()">
  <div class="category">{{ category }}</div>
  <ng-template [ngIf]="discount && !deviceService.isMobile() && !deviceService.isTablet()">
    <div class="discount">{{ 'library.user-service-card.discount' | translate }} {{ discount }}%</div>
  </ng-template>

  <div class="info-block" *ngIf="!deviceService.isMobile() && !deviceService.isTablet()">
    <div class="cover-block">
      <on-ui-cover [cover]="coverImage" [scale]="true"></on-ui-cover>
    </div>
    <div class="left">
      <span class="subject">{{ subject }}</span>
      <span class="title">{{ title }}</span>
      <div class="author-wrap">
        <div class="author-avatar-wrap">
          <on-ui-cover [cover]="authorAvatar"></on-ui-cover>
        </div>
        <a [routerLink]="accountRoute" class="author-name">{{ authorFullName }}</a>
        <div class="teacher-separator"></div>
        <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
        <div class="teacher-separator"></div>
        <span
          class="lessons-count">{{ 'library.user-service-card.lessons-count' | translate }} {{ stats?.meetings_count }}</span>
      </div>
    </div>
    <div class="right">
      <div class="period-wrap">
        <app-icon width="15" height="15" icon="period"></app-icon>
        <span class="period">{{ duration }} {{ 'library.user-service-card.min' | translate }}</span>
      </div>
      <span class="price">
        {{ price_tier ? (getFormattedAmount() | async) : 0 }}
      </span>
      <ng-template [ngIf]="discount">
        <div class="discount">{{ 'library.user-service-card.discount' | translate }} {{ discount }}%</div>
      </ng-template>
    </div>
  </div>

  <div class="action-block" *ngIf="!deviceService.isMobile() && !deviceService.isTablet()">
    <ng-template [ngIf]="userService?.can?.signup"
                 [ngIfThen]="availableActionsRef"
                 [ngIfElse]="notAvailableActionsRef">
    </ng-template>
  </div>

  <div class="new-cta" *ngIf="deviceService.isMobile() || deviceService.isTablet()">
    <div class="top">
      <div class="price">
        <div class="price-block">
          <span class="price-value">{{ price_tier ? (getFormattedAmount() | async) : 0 }}</span>
        </div>
<!--        <span class="old-price-block" *ngIf="discount">-->
<!--          <span class="through">-->
<!--            {{ formatAmount(getPriceTier(price_tier) | async) }}-->
<!--          </span>-->
<!--        </span>-->
<!--        <ng-template [ngIf]="discount">-->
<!--          <div class="discount">{{ 'library.user-service-card.discount' | translate }} {{ discount }}%</div>-->
<!--        </ng-template>-->
      </div>
    </div>
    <ng-template [ngIf]="userService?.can?.signup"
                 [ngIfThen]="availableActionsRef"
                 [ngIfElse]="notAvailableActionsRef">
    </ng-template>
  </div>


</div>

<ng-template #ratingWrap>
  <app-rating [stats]="stats"></app-rating>
</ng-template>

<ng-template #availableActionsRef>
  <on-ui-button *ngIf="userService?.can?.signup"
                class="secondary"
                [label]="isRegularClass() ? 'library.user-service-card.subscribe' : 'library.user-service-card.sign-up'"
                (click)="openCheckoutModal()">
  </on-ui-button>
</ng-template>

<ng-template #notAvailableActionsRef>
  <on-ui-button class="status"
                label="teacher-card.actions.no-available-hours">
  </on-ui-button>
</ng-template>
